import FaqDetail from './faq-detail';

export default FaqDetail;
